import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    liveCaptionViewOn: false,
    captionInProgress: false,
    captionList: [],
    liveCaptionBuffer: [], // captions waiting to be sent
    pendingLiveCaptionUploadData: [], // captions while posting
    startLiveCaptionUploading: false,
    captionTextOn: false,
    storeTranscriptionData: {
        loading: false,
        data: false,
        error: false,
    },
    localUserLiveCaptionStart: false,
    localUserLiveCaptionStop: false,
};
const liveCaptionReducerSlice = createSlice({
    name: "liveCaptionReducer",
    initialState,
    reducers: {
        setLiveCaptionViewOn(state, action) {
            state.liveCaptionViewOn = action.payload;
        },
        setCaptionInProgress(state, action) {
            state.captionInProgress = action.payload;
        },
        setCaptionList(state, action) {
            state.captionList = action.payload;
        },
        addOrUpdateCaption: (state, action) => {
            const { isAgent, participantID, participantName, transcription, partial_results, callDuration, timestamp, epochTimeStamp, createTime } =
                action.payload;

            // Find existing unfinished caption in captionList
            const existingIndex = state.captionList.findIndex((c) => c.participantID === participantID && !c.isFinal);

            let updatedCaption;

            if (partial_results) {
                // Partial → update or create
                if (existingIndex !== -1) {
                    // 🔹 fully update all keys for existing line
                    state.captionList[existingIndex] = {
                        ...state.captionList[existingIndex],
                        partial_results,
                        text: transcription,
                        callDuration,
                        twilioTimeStamp: timestamp,
                        systemTimeStamp: epochTimeStamp,
                        createTime,
                        isFinal: false,
                    };

                    updatedCaption = { ...state.captionList[existingIndex] };
                } else {
                    updatedCaption = {
                        isAgent,
                        participantID,
                        name: participantName,
                        partial_results,
                        text: transcription,
                        callDuration,
                        twilioTimeStamp: timestamp,
                        systemTimeStamp: epochTimeStamp,
                        createTime,
                        isFinal: false,
                    };
                    state.captionList.push(updatedCaption);
                }
            } else {
                // Final → lock this caption
                if (existingIndex !== -1) {
                    // 🔹 fully update all keys for final line
                    state.captionList[existingIndex] = {
                        ...state.captionList[existingIndex],
                        partial_results,
                        text: transcription,
                        callDuration,
                        twilioTimeStamp: timestamp,
                        systemTimeStamp: epochTimeStamp,
                        createTime,
                        isFinal: true,
                    };

                    updatedCaption = { ...state.captionList[existingIndex] };
                } else {
                    updatedCaption = {
                        isAgent,
                        participantID,
                        name: participantName,
                        partial_results,
                        text: transcription,
                        callDuration,
                        twilioTimeStamp: timestamp,
                        systemTimeStamp: epochTimeStamp,
                        createTime,
                        isFinal: true,
                    };
                    state.captionList.push(updatedCaption);
                }
            }
            if (updatedCaption.isFinal) {
                state.liveCaptionBuffer.push(updatedCaption);
            }
        },
        startLiveCaptionUpload: (state) => {
            state.startLiveCaptionUploading = true;
            state.pendingLiveCaptionUploadData = [...state.liveCaptionBuffer];
            state.liveCaptionBuffer = [];
        },

        completeLiveCaptionUpload: (state) => {
            state.startLiveCaptionUploading = false;
            state.pendingLiveCaptionUploadData = [];
        },

        failedLiveCaptionUpload: (state) => {
            state.startLiveCaptionUploading = false;
            state.liveCaptionBuffer = [...state.pendingLiveCaptionUploadData, ...state.liveCaptionBuffer];
            state.pendingLiveCaptionUploadData = [];
        },
        resetCaptions: (state) => {
            state.captionList = [];
            state.liveCaptionBuffer = [];
            state.pendingLiveCaptionUploadData = [];
            state.startLiveCaptionUploading = false;
        },
        setCaptionTextOn(state, action) {
            state.captionTextOn = action.payload;
        },
        updateStoreTranscriptionStatus(state, action) {
            const { loading = false, data = false, error = false, reset = false } = action.payload;
            if (reset) {
                /* Reset the 'storeTranscriptionData' state */
                return {
                    ...state,
                    storeTranscriptionData: initialState.storeTranscriptionData,
                };
            }
            /* set the'storeTranscriptionData' state */
            state.storeTranscriptionData.loading = loading;
            state.storeTranscriptionData.data = data;
            state.storeTranscriptionData.error = error;
        },
        setLocalUserLiveCaptionStart(state, action) {
            state.localUserLiveCaptionStart = action.payload;
        },
        setLocalUserLiveCaptionStop(state, action) {
            state.localUserLiveCaptionStop = action.payload;
        },
        resetLiveCaptionReducer() {
            return initialState;
        },
    },
});

export const {
    setLiveCaptionViewOn,
    setCaptionInProgress,
    setCaptionList,
    addOrUpdateCaption,
    startLiveCaptionUpload,
    completeLiveCaptionUpload,
    failedLiveCaptionUpload,
    setCaptionTextOn,
    setLocalUserLiveCaptionStart,
    setLocalUserLiveCaptionStop,
    updateStoreTranscriptionStatus,
    resetCaptions,
    resetLiveCaptionReducer,
} = liveCaptionReducerSlice.actions;
export default liveCaptionReducerSlice.reducer;
